module.exports = __webpack_public_path__ + "img/down.737afbd1.svg";